import { renderCheckout } from '../../checkout/CheckoutEntry';

renderCheckout();
